import { FC, useEffect } from 'react'

import styled from 'styled-components'
import { useNavigate, useParams } from 'react-router-dom'

import { Breadcrumb } from 'src/Components/Breadcrumb'
import { create, signUpArtist } from 'src/Router/routes'
import { ChosenTrack } from 'src/Components/ChosenTrack'
import { CampaignPlatformTypeEnum, CampaignTypeEnum } from 'src/Types/campaigns'
import { useFirstChosenTrack } from 'src/Hooks/useFirstChosenTrack'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { toggleActivatedEvent } from 'src/Helpers/TagManager'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import { getValueOrEmptyString } from 'src/Helpers/layoutHelpers'
import { getValueOrZero } from 'src/Constants/functions'
import { usePageViewEvent } from 'src/Hooks/Analytics/useTrackEvents'

import { NoAuthPageLayout } from '../../Components/NoAuthPageLayout'

const ContentContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 960px;
  flex-direction: column;
  margin: 0 auto;
  align-items: flex-start;
  gap: 40px;
  @media screen and (min-width: ${MAX_MOBILE_WIDTH}) {
    gap: 16px;
  }
`

const getTitle = (platform?: CampaignPlatformTypeEnum): string =>
  platform === CampaignPlatformTypeEnum.TIKTOK
    ? 'New TikTok Campaign'
    : 'New Spotify Campaign'

export const SelectedTrackNoAuth: FC = () => {
  const navigate = useNavigate()
  const { trackId } = useParams()
  const { loading, platform, isSuccess, unifyTrack } = useFirstChosenTrack()
  const { search } = useCustomSearchParams()
  const { trackAddedEventHandler } = usePageViewEvent()

  const handleCreate = (): void => {
    navigate(
      `${create}/${platform}/${trackId}${signUpArtist}?${search.toString()}`,
    )
  }

  const handleBackClick = (): void => {
    navigate(`${create}/${platform}?${search.toString()}`)
  }

  useEffect(() => {
    if (platform && unifyTrack?.artistName && isSuccess) {
      trackAddedEventHandler({
        artistName: getValueOrEmptyString(unifyTrack?.artistName),
        platformType: platform,
        trackDuration: getValueOrZero(unifyTrack?.trackDurationInMs),
        trackId: getValueOrEmptyString(unifyTrack?.trackId),
        trackName: getValueOrEmptyString(unifyTrack?.trackName),
      })
      toggleActivatedEvent({
        platformName: platform,
        campaignType: CampaignTypeEnum.FIRST,
        campaignNumber: 1,
      })
    }
  }, [
    isSuccess,
    platform,
    unifyTrack?.artistName,
    unifyTrack?.trackDurationInMs,
    unifyTrack?.trackId,
    unifyTrack?.trackName,
    trackAddedEventHandler,
  ])

  const items = [
    {
      path: create,
      title: 'Choosing campaign',
    },
    {
      path: `${create}/${platform}`,
      title: 'Track search',
    },
  ]

  const title = getTitle(platform)

  return (
    <NoAuthPageLayout>
      <ContentContainer>
        <Breadcrumb onButtonClick={handleBackClick} items={items} />
        <ChosenTrack
          title={title}
          loading={loading}
          artist={unifyTrack?.artistName}
          trackName={unifyTrack?.trackName}
          trackUrl={unifyTrack?.trackPreviewUrl}
          image={unifyTrack?.trackCoverUrl}
          duration={unifyTrack?.trackDuration}
          onCreateClick={handleCreate}
          onChangeClick={handleBackClick}
        />
      </ContentContainer>
    </NoAuthPageLayout>
  )
}
